import find from 'lodash/find';
import map from 'lodash/map';
import each from 'lodash/each';
import storage from 'viralstyle-ui/src/storage';

import logger from '../../utils/logger';

class Klaviyo {
  constructor() {
    this.klaviyo = window._learnq || [];
  }

  $_cartPayload(cart) {
    let payload = {
      '$value': cart.totals.subtotal,
      ItemNames: map(cart.items, item => item.campaign_name),
      CheckoutUrl: 'https://viralstyle.com/purchase/checkout',
      Items: [],
    };

    each(cart.items, item => {
      let categories = item.campaign_category.split('>');

      let itemPayload = {
        ProductID: item.product_id,
        CampaignProductID: item.id,
        SKU: item.product_sku,
        ProductName: item.campaign_name,
        Quantity: item.quantity,
        ItemPrice: item.price_per_unit,
        RowTotal: item.price,
        Size: item.size,
        Color: item.color,
        ProductURL: `https://viralstyle.com/${item.public_name}/${item.campaign_slug}`,
        ImageURL: item.thumb,
      };

      if (categories.length > 1) {
        itemPayload.ProductCategories = [categories[0].trim(), categories[1].trim()];
      }

      payload.Items.push(itemPayload);
    });

    return payload;
  }

  identify(vuex) {
    let customer = vuex.rootState.checkout.customer,
      payload = {};

    logger.groupCollapsed('VS Klaviyo');

    if (customer.email) {
      payload['$email'] = customer.email;
    }

    if (customer.name) {
      let names = customer.name.split(' ');

      payload['$first_name'] = names[0];

      if (names.length > 1) {
        payload['$last_name'] = names[names.length - 1];
      }
    }

    if (customer.phone) {
      payload['$phone_number'] = customer.phone;
    }

    if (Object.keys(payload).length) {
      this.klaviyo.push(['identify', payload]);

      logger.log('Identify Payload:');
      logger.log(payload);
    }

    logger.groupEnd();
  }

  vsViewSales(state, product, color, price) {
    logger.groupCollapsed('VS Klaviyo');

    let campaign = state.sales.campaign,
      item = {
        ProductName: campaign.name,
        ProductID: product.id,
        CampaignProductID: color.id,
        ImageURL: color[`${product.default_side.toLowerCase()}_url`],
        URL: `https://viralstyle.com${campaign.url}`,
        Brand: product.brand,
        Price: price,
        Color: color.name,
      },
      categories = campaign.category.split('>');

    if (categories.length > 1) {
      item.Categories = [categories[0].trim(), categories[1].trim()];
    }

    this.klaviyo.push(['track', 'Viewed Product', item]);

    let legacyItem = {
      Title: item.ProductName,
      ItemId: item.ProductID,
      ImageUrl: item.ImageURL,
      Url: item.URL,
      Metadata: {
        Brand: item.Brand,
        Price: item.Price,
        Color: item.Color,
      },
    };

    if (categories.length > 1) {
      legacyItem.Categories = [categories[0].trim(), categories[1].trim()];
    }

    this.klaviyo.push(['trackViewedItem', legacyItem]);

    logger.log('viewed product event with payload:');
    logger.log(item);
    logger.log('track viewed item event with payload:')
    logger.log(legacyItem);

    logger.groupEnd();
  }

  vsAddToCart(state, selectedProduct, price, size, quantity, cpid) {
    let cart = state.cart.cart,
      campaign = state.sales.campaign,
      color = find(selectedProduct.colors, productColor => productColor.id === cpid);

    logger.groupCollapsed('VS Klaviyo');

    let payload = {
        ...this.$_cartPayload(cart),
        AddedItemProductName: campaign.name,
        AddedItemProductID: selectedProduct.id,
        AddedItemCampaignProductID: cpid,
        AddedItem_SKU: selectedProduct.sku,
        AddedItem_ImageURL: color[`${selectedProduct.default_side.toLowerCase()}_url`],
        AddedItem_URL: `https://viralstyle.com${campaign.url}`,
        AddedItem_Price: price,
        AddedItem_Quantity: quantity,
        AddedItem_Size: size,
        AddedItem_Color: color.name,
      },
      categories = campaign.category.split('>');

    if (categories.length > 1) {
      payload.AddedItem_Categories = [categories[0].trim(), categories[1].trim()];
    }

    this.klaviyo.push(['track', 'Added to Cart', payload]);

    logger.log('add to cart event with payload:');
    logger.log(payload);

    logger.groupEnd();
  }

  vsInitiateCheckout(state) {
    let cartParams = storage.get('cart').split('/');

    logger.groupCollapsed('VS Klaviyo');

    let payload = {
      '$event_id': `${cartParams[cartParams.length - 1].replace('_', '')}_${Math.round(+new Date()/1000)}`,
      ...this.$_cartPayload(state.rootState.cart.cart),
    };

    this.klaviyo.push(['track', 'Started Checkout', payload]);

    logger.log('started checkout event with payload:');
    logger.log(payload);

    logger.groupEnd();
  }
};

export default new Klaviyo();